var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"home-page-upper-cards-section"},[_c('v-container',[_c('v-row',{staticClass:"align-items-stretch"},_vm._l((_vm.cards),function(card,index){return _c('v-col',{key:index,attrs:{"cols":"12","xl":"4","lg":"4","md":"4","sm":"12"}},[_c('home-page-card',{attrs:{"data":card}})],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }